import { render, staticRenderFns } from "./DeliverySpaceList.vue?vue&type=template&id=019373c0&"
import script from "./DeliverySpaceList.vue?vue&type=script&lang=ts&"
export * from "./DeliverySpaceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports